import { CtaShell } from "./cta-shell"
import type { CtaShellProps } from "./cta-types"

export type SplitFormCtaProps = CtaShellProps

export function SplitFormCta(props: SplitFormCtaProps) {
  return <CtaShell {...props} layout="split-form" />
}
